import { AppCurrency } from '@components/AppCurrency';
import { EMPTY_LABEL } from '@utils/text/commonText';

import { withCellValue } from '../withCellValue';

const CurrencyCell = withCellValue(({ children }) => (
  <AppCurrency fallbackValue={EMPTY_LABEL} emptyValue={EMPTY_LABEL}>
    {children}
  </AppCurrency>
));

export { CurrencyCell };
